// Data
import propertyReportService from "data/reports-property"
import React, { FC } from "react"
// Styles
import { ButtonWithPress_s } from "styles/app-styles"

interface RoomsProps {
  property: object
}

const Rooms: FC<RoomsProps> = (props) => {
  
  function submit():void {
    propertyReportService.propertyReport({
      report: 'hospitality_input_assumptions',
      params: {
        selected_reports: ["rooms"]
      }
    })
  }

  return (
    <div>
      <ButtonWithPress_s primary onClick={submit}>Run Report</ButtonWithPress_s>
    </div>
  )
}

export default Rooms
